// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__34AmC","label":"LabeledBox_label__2p_uY"};